import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  addFeatureButtonSectionHeader: {
    cursor: 'pointer',
    ':hover': {
      backgroundColor: theme.palette.neutralLighter,
    },
    ':active': {
      backgroundColor: theme.palette.neutralLight,
    },
  },
  addFeatureButtonSectionHeaderDisabled: {
    backgroundColor: theme.palette.neutralLighter,
    ':hover': {
      backgroundColor: theme.palette.neutralLighter,
    },
    ':active': {
      backgroundColor: theme.palette.neutralLighter,
    },
    cursor: 'default',
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  panelHeading: {
    selectors: {
      '.ms-Panel-headerText': {
        padding: `${pxToRem(14)} 0 ${pxToRem(4)} ${pxToRem(8)}`,
        borderBottom: `${pxToRem(2)} solid ${theme.palette.neutralTertiaryAlt}`,
      },
    },
  },
});
